var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { class: ["h-100", "d-flex", "flex-column", _vm.theme] }, [
    _c(
      "div",
      {
        staticClass:
          "editor-toolbar d-flex align-items-center justify-content-between p-1 form-inline",
      },
      [
        _c("div", { staticClass: "d-flex align-items-center" }, [
          _c("label", { staticClass: "mr-1 mb-0 p-1" }, [
            _vm._v(_vm._s(_vm.T.fontSize)),
          ]),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectedFontSize,
                  expression: "selectedFontSize",
                },
              ],
              staticClass: "custom-select-sm",
              on: {
                change: [
                  function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.selectedFontSize = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  _vm.onFontSizeChange,
                ],
              },
            },
            _vm._l(_vm.fontSizes, function (size) {
              return _c("option", { key: size, domProps: { value: size } }, [
                _vm._v(" " + _vm._s(size) + "px "),
              ])
            }),
            0
          ),
        ]),
        _c(
          "button",
          {
            staticClass: "btn btn-sm btn-secondary",
            attrs: { title: _vm.T.resetToDefault },
            on: { click: _vm.onReset },
          },
          [
            _c("font-awesome-icon", {
              attrs: { icon: ["fas", "undo"], "aria-hidden": "true" },
            }),
          ],
          1
        ),
      ]
    ),
    _c("div", {
      ref: "editorContainer",
      staticClass: "editor flex-grow-1 w-100 h-100",
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }